import { render, staticRenderFns } from "./postFull.vue?vue&type=template&id=4a46b428&"
import script from "./postFull.vue?vue&type=script&lang=js&"
export * from "./postFull.vue?vue&type=script&lang=js&"
import style0 from "./postFull.vue?vue&type=style&index=0&id=4a46b428&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports